'use client'

// src/components/ui/ExtendedElement/ExtendedElement.tsx
import { twMerge as twMerge2 } from "tailwind-merge";
import { Button } from "@wbk/ui";

// src/components/ui/ExtendedElement/ExtendedElement.classes.tsx
import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
var CutoutSVG = ({ position, className }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "48",
    height: "56",
    viewBox: "0 0 48 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: twMerge(
      `text-secondary relative transition-none ${position === "left" ? "-me-S ltr:scale-x-[-1]" : "-ms-S rtl:scale-x-[-1]"}`,
      className
    ),
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24 32V24C24 10.7452 34.7452 0 48 0V56H0C13.2548 56 24 45.2548 24 32Z",
        fill: "currentColor"
      }
    )
  }
);

// src/components/ui/ExtendedElement/ExtendedElement.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
function ExtendedElement({
  index,
  total,
  activeIndex,
  label,
  onClick,
  className,
  cutoutClassName
}) {
  const isActive = activeIndex === index;
  const showLeft = index > 0 && index <= total - 1;
  const showRight = index === 0 || index > 0 && index <= total - 1;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      "data-active": isActive,
      "data-index": index,
      className: twMerge2("bg-secondary flex data-[active=true]:bg-transparent", className),
      children: [
        isActive && showLeft && /* @__PURE__ */ jsx2(CutoutSVG, { position: "left", className: cutoutClassName }),
        /* @__PURE__ */ jsx2(
          Button,
          {
            onClick,
            phill: true,
            className: "mb-S whitespace-nowrap transition-none",
            theme: isActive ? "primary" : "transparent",
            children: label
          }
        ),
        isActive && showRight && /* @__PURE__ */ jsx2(CutoutSVG, { position: "right", className: cutoutClassName })
      ]
    }
  );
}

export {
  ExtendedElement
};
//# sourceMappingURL=chunk-OB4IP4Y7.mjs.map